import vue from '@/main'
import axios from "axios"

export default {
  delete(filename, headers) {
    vue.$vs.loading({
      type: 'radius',
      text: 'Removendo arquivo...'
    });

    return new Promise((resolve, reject) => {
      axios.delete(
        `${localStorage.getItem('baseUrl')}/api/file/delete/${filename}`,
        { headers }
      )
      .then(() => {
        vue.$vs.loading.close()
        resolve(true)
      })
      .catch(() => {
        vue.$vs.loading.close()
        reject(false)
      })
    })
  }
}